<div id="loader" class="loader-overlay" style="display: block;" *ngIf="showSpinner">
    <div class="loader-wrapper">
        <div class="d-flex justify-content-center">
            <img src="https://www.truckit.net/api/media/loader.gif">
        </div>
        <label></label>
    </div>
</div>